/**
 * A folder-share link (`?folder_share=TOKEN`) the visitor arrived with,
 * handled the way a paid buyer invite is (lib/buyerInvite.ts): captured off
 * the URL on the marketing page, held in localStorage across sign-in or
 * sign-up (which goes through an email verification tab), and claimed by the
 * studio shell on arrival with a session.
 */
const KEY = "vs_folder_share_invite";

export function captureFolderShareFromUrl(): string | null {
  try {
    const params = new URLSearchParams(window.location.search);
    const token = (params.get("folder_share") || "").trim();
    if (token) {
      window.localStorage.setItem(KEY, token);
      params.delete("folder_share");
      const rest = params.toString();
      window.history.replaceState({}, "", `${window.location.pathname}${rest ? `?${rest}` : ""}${window.location.hash}`);
      return token;
    }
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function getStoredFolderShare(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearStoredFolderShare(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
